import * as THREE from 'three';
import { LODToaster } from './LODToaster';
import { UpdatePriority } from './DynamicObject';

/**
 * Medium toaster - cow sized and medium speed
 */
export class LODToasterMedium extends LODToaster {
  constructor() {
    // Create with medium toaster specific configuration
    // Cow-sized and medium speed
    super(
      'LODToasterMedium', 
      new THREE.Vector3(1.5, 1.5, 1.5),  // 1.5 meters in size (cow-sized)
      1.5  // Medium movement speed
    );
    
    // The SpatialManager will dynamically adjust priority based on distance and visibility
  }
  
  /**
   * Override health initialization for medium toasters
   * Medium toasters have moderate health and speed
   */
  protected override initializeHealth(): void {
    // Medium toasters have 150 health
    this.maxHealth = 150;
    this.currentHealth = this.maxHealth;
    
    console.log(`Initialized medium toaster ${this.getId()} with ${this.maxHealth} health`);
  }
} 